// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  let queued = false;
  let pending = null, toastTimer;
  function toast(item) {
    document.querySelector('.sp-wishlist-toast')?.remove();
    clearTimeout(toastTimer);
    const box = document.createElement('div');
    box.className = 'sp-wishlist-toast';
    box.setAttribute('role','status');
    const close = document.createElement('button');
    close.className = 'sp-wishlist-toast__close';
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label','Meldung schließen');
    close.addEventListener('click',()=>box.remove());
    if (item.image) {
      const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 48; image.height = 64; box.append(image);
    }
    const copy = document.createElement('div');
    const title = document.createElement('strong'); title.textContent = 'Auf deiner Wunschliste';
    const name = document.createElement('p'); name.textContent = item.name;
    const open = document.createElement('button'); open.type = 'button'; open.className = 'sp-wishlist-toast__view';
    open.innerHTML = 'Wunschliste ansehen <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    open.addEventListener('click',()=>{document.querySelector('.wishlist-hero-header-icon')?.click();box.remove();});
    copy.append(title,name,open); box.append(copy,close); document.body.append(box);
    toastTimer = setTimeout(()=>box.remove(),6500);
  }
  function sync() {
    queued = false;
    const header = document.querySelector('header.header');
    const block = header?.querySelector('.wishlisthero-header-block');
    const menu = header?.querySelector('header-drawer');
    const icons = header?.querySelector('.header__icons');
    if (block && menu && icons) {
      if (mobile.matches) {
        if (block.parentElement !== header) header.append(block);
        if (!block.classList.contains('sp-mobile-wishlist')) block.classList.add('sp-mobile-wishlist');
        const h = header.getBoundingClientRect(), m = menu.getBoundingClientRect();
        const left = `${Math.round(m.right - h.left)}px`, top = `${Math.round(m.top - h.top)}px`;
        if (block.style.getPropertyValue('--sp-wishlist-left') !== left) block.style.setProperty('--sp-wishlist-left', left);
        if (block.style.getPropertyValue('--sp-wishlist-top') !== top) block.style.setProperty('--sp-wishlist-top', top);
      } else {
        if (block.classList.contains('sp-mobile-wishlist')) block.classList.remove('sp-mobile-wishlist');
        if (block.parentElement !== icons) icons.insertBefore(block, icons.querySelector('#cart-icon-bubble'));
      }
      // Erst sichtbar, wenn es an seinem Platz steht - sonst blitzt es bei jedem
      // Seitenaufruf kurz rechts neben der Lupe auf, bevor es nach links springt.
      block.classList.add('sp-wishlist-placed');
    }
    if (pending) {
      if (Date.now() - pending.time > 10000) pending = null;
      else if (pending.host.querySelector('button.wishlisthero-product-in-wishlist')) { const item = pending; pending = null; toast(item); }
    }
    document.querySelectorAll('.wishlist-hero-header-close').forEach(e => { if (!e.hasAttribute('aria-label')) e.setAttribute('aria-label','Wunschliste schließen'); });
    document.querySelectorAll('.wishlist-hero-list-card-footer-delete').forEach(e => { if (!e.hasAttribute('aria-label')) e.setAttribute('aria-label','Artikel entfernen'); });
    document.querySelectorAll('.wishlist-hero-price-update [data-wlh-item-price]').forEach(e => {
      const raw = e.getAttribute('data-wlh-item-price');
      if (!/^€\s*\d+(?:,\d{3})*(?:\.\d{2})?$/.test(raw)) return;
      const value = Number(raw.replace(/[€,\s]/g,''));
      const text = new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(value);
      if (e.textContent !== text) e.textContent = text;
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
  // Notbremse: sollte die App den Block nie liefern oder sync nie laufen, darf das
  // Herz trotzdem nicht dauerhaft verborgen bleiben.
  setTimeout(() => document.querySelectorAll('.wishlisthero-header-block').forEach(b => b.classList.add('sp-wishlist-placed')), 2500);
  const closingDialogs = new WeakSet();
  const nativeCloseClicks = new WeakSet();
  document.addEventListener('click', event => {
    const close = event.target.closest('.wishlist-hero-header-close');
    if (!close || nativeCloseClicks.has(close) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const dialog = close.closest('.MuiDialog-paper');
    if (!dialog) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (closingDialogs.has(dialog)) return;
    closingDialogs.add(dialog);
    dialog.classList.add('sp-wishlist-closing');
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      nativeCloseClicks.add(close);
      if (close.isConnected) close.click();
      nativeCloseClicks.delete(close);
      // Retained app dialogs must open normally on the next visit.
      setTimeout(() => { dialog.classList.remove('sp-wishlist-closing'); closingDialogs.delete(dialog); }, 300);
    };
    dialog.addEventListener('animationend', event => {
      if (event.target === dialog && event.animationName === 'sp-wishlist-close') finish();
    }, { once: true });
    setTimeout(finish, 380);
  }, true);
  document.addEventListener('click',event=>{
    const button = event.target.closest('.wishlisthero-floating button,.sp-product-wishlist button');
    if (!button || button.classList.contains('wishlisthero-product-in-wishlist')) return;
    const card = button.closest('.card-wrapper'), product = button.closest('product-info');
    const host = button.closest('.wishlisthero-floating,.sp-product-wishlist');
    pending = {host,time:Date.now(),name:card?.querySelector('.card__heading')?.textContent.trim() || product?.querySelector('h1')?.textContent.trim() || 'Dein Lieblingsstück',image:card?.querySelector('img')?.currentSrc || product?.querySelector('.product__media img')?.currentSrc};
    schedule();
  },true);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  mobile.addEventListener('change',schedule);
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  sync();
})();
